import React, { useEffect } from "react";
import { Card } from "antd";
import sal from "sal.js";
import "sal.js/dist/sal.css";
import "./Explore.css";
import demoMap from "./map_demographics.png";
import greeneryMap from "./map_greenery.png";
import { Link } from "react-router-dom";

export default function Explore({ setRoute }) {
  const cardStyle = {
    boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
    width: "45%",
    margin: "1rem",
    borderRadius: "6px",
    overflow: "hidden",
    display: "inline-block",
    padding: "0",
    cursor: "pointer",
  };

  useEffect(() => {
    sal();
  }, []);

  return (
    <div style={{ padding: "2rem 6rem" }} className="explore">
      <h1 data-sal="fade" data-sal-duration="800">
        Explore Community Learning Kits
      </h1>
      <h3 data-sal="fade" data-sal-delay="50" data-sal-duration="600">
        Our story maps provide intuition on emerging situations.
      </h3>

      <br />
      <div>
        <Link
          onClick={() => {
            setRoute("/community-diversity");
          }}
          to="/community-diversity"
        >
          <Card
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-duration="800"
            style={cardStyle}
            cover={<img src={demoMap} />}
          >
            <h1>Community Diversity Map</h1>
            <p>A useful guide to help you find the community for your cultural needs in Palo Alto.</p>
          </Card>
        </Link>
        <Link
          onClick={() => {
            setRoute("/community-greenery");
          }}
          to="/community-greenery"
        >
          <Card
            data-sal="slide-up"
            data-sal-delay="200"
            data-sal-duration="800"
            style={cardStyle}
            cover={<img src={greeneryMap} />}
          >
            <h1>Community Greenery Map</h1>
            <p>The importance of trees & plants where you live, and how your community is tracking & lacking.</p>
          </Card>
        </Link>
        <div style={{ height: "40rem" }} />
      </div>
    </div>
  );
}
